import commonDataAccess from "../commonDataAccess";

class productionHoursDataAccess {
    getProductionWeekSchedule(weekStartDate: string) {
        return commonDataAccess.getData("productionweekschedule/get/production-week-schedule", { weekStartDate });
    }
    saveProductionWeekSchedule(model: any) {
        return commonDataAccess.postData("productionweekschedule/save/production-week-schedule", model);
    }
    getWeekNumber(weekStartDate: string) {
        return commonDataAccess.getData("productionweekschedule/get/week-number", { weekStartDate });
    }
}

export default new productionHoursDataAccess();